import { render, staticRenderFns } from "./FormulaModal.vue?vue&type=template&id=217edf10&scoped=true&"
import script from "./FormulaModal.vue?vue&type=script&lang=js&"
export * from "./FormulaModal.vue?vue&type=script&lang=js&"
import style0 from "./FormulaModal.vue?vue&type=style&index=0&id=217edf10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217edf10",
  null
  
)

export default component.exports